<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Vehicles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Vehicles",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Vehicles",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "make",
          sortable: true,
          label: "MAKE",
        },
        {
          key: "model",
          sortable: true,
          label: "MODEL",
        },
        {
          key: "vin",
          sortable: true,
          label: "VIN",
        },
        {
          key: "plate_number",
          sortable: true,
          label: "PLATE",
        },
        {
          key: "purchase_price",
          sortable: true,
          label: "PURCHASE PRICE",
        },
        {
          key: "current_value",
          sortable: true,
          label: "CURRENT VALUE",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      existingCategory: [],
      makeError: "",
      modelError: "",
      vinError: "",
      plateNumberError: "",
      purchasePriceError: "",
      currentValueError: "",
      purchaseDateError: "",

      // Value from user input for adding category
      data: {
        make: "",
        model: "",
        vin: "",
        plate_number: "",
        purchase_date: "",
        purchase_price: "",
        current_value: "",
      },
      // edit category
      editdata: {
        make: "",
        model: "",
        vin: "",
        plate_number: "",
        purchase_date: "",
        purchase_price: "",
        id: "",
      },
      // delete category
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("vehicles", ["Vehicles", "SaveStatus"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Vehicles ? this.Vehicles.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Vehicles ? this.Vehicles.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchVehicles: "vehicles/fetchVehicles",
      AddVehicle: "vehicles/addVehicle",
      EditVehicle: "vehicles/editVehicle",
      DeleteVehicle: "vehicles/deleteVehicle",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      if (this.data.name != "") {
        this.existingCategory = this.Vehicles.filter((category) => {
          return category.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingCategory.length) {
          this.makeError = this.data.name + " exists already";
        } else {
          this.makeError = "";
        }
      } else {
        this.existingCategory = [];
      }
    },

    addVehicle(modalId) {
      this.modal_id = modalId;

      if (this.data.make === "") {
        this.makeError = "Vehicle Make is required";
        return;
      } else {
        this.makeError = "";
      }

      if (this.data.model === "") {
        this.modelError = "Vehicle model is required";
        return;
      } else {
        this.modelError = "";
      }
      if (this.data.vin === "") {
        this.vinError = "Vehicle Identification Number is required";
        return;
      } else {
        this.vinError = "";
      }
      if (this.data.plate_number === "") {
        this.plateNumberError = "Vehicle Plate Number is required";
        return;
      } else {
        this.plateNumberError = "";
      }

      if (this.data.purchase_date === "") {
        this.purchaseDateError = "Vehicle Purchase Date is required";
        return;
      } else {
        this.purchaseDateError = "";
      }

      if (this.data.purchase_price === "") {
        this.purchase_price = "Vehicle Purchase Price is required";
        return;
      } else {
        this.purchase_price = "";
      }

      if (this.data.current_value === "") {
        this.currentValueError = "Vehicle Current Value is required";
        return;
      } else {
        this.currentValueError = "";
      }
      // if (this.existingCategory.length) {
      //   this.makeError = this.data.name + " exists already please";
      //   return;
      // } else {
      //   this.makeError = "";
      // }

      this.AddVehicle(this.data);
    },

    resetAdd() {
      this.data.make = "";
      this.data.model = "";
      this.data.vin = "";
      this.data.plate_number = "";
      this.data.purchase_date = "";
      this.data.purchase_price = "";
      this.data.current_value = "";

      this.makeError = "";
      this.modelError = "";
      this.vinError = "";
      this.plateNumberError = "";
      this.purchasePriceError = "";
      this.currentValueError = "";
      this.modal_id = "";
    },
    resetEditCat() {
      this.editdata.make = "";
      this.editdata.model = "";
      this.editdata.vin = "";
      this.editdata.plate_number = "";
      this.editdata.purchase_date = "";
      this.editdata.purchase_price = "";
      this.editdata.current_value = "";

      this.makeError = "";
      this.modelError = "";
      this.vinError = "";
      this.plateNumberError = "";
      this.purchasePriceError = "";
      this.currentValueError = "";
      this.modal_id = "";
    },

    resetDeleteCat() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.makeError = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.makeError = "";
      this.modelError = "";
      this.vinError = "";
      this.plateNumberError = "";
      this.purchasePriceError = "";
      this.currentValueError = "";
    },
    showEditModal(data) {
      this.editdata.make = data.item.make;
      this.editdata.model = data.item.model;
      this.editdata.vin = data.item.vin;
      this.editdata.plate_number = data.item.plate_number;
      this.editdata.purchase_date = data.item.purchase_date;
      this.editdata.purchase_price = data.item.purchase_price;
      this.editdata.current_value = data.item.current_value;
      this.editdata.id = data.item.id;
    },
    editVehicle(modalId) {
      this.modal_id = modalId;
      if (this.editdata.make === "") {
        this.makeError = "Vehicle Make is required";
        return;
      } else {
        this.makeError = "";
      }

      if (this.editdata.model === "") {
        this.modelError = "Vehicle model is required";
        return;
      } else {
        this.modelError = "";
      }
      if (this.editdata.vin === "") {
        this.vinError = "Vehicle Identification Number is required";
        return;
      } else {
        this.vinError = "";
      }
      if (this.editdata.plate_number === "") {
        this.plateNumberError = "Vehicle Plate Number is required";
        return;
      } else {
        this.plateNumberError = "";
      }

      if (this.editdata.purchase_date === "") {
        this.purchaseDateError = "Vehicle Purchase Date is required";
        return;
      } else {
        this.purchaseDateError = "";
      }

      if (this.editdata.purchase_price === "") {
        this.purchase_price = "Vehicle Purchase Price is required";
        return;
      } else {
        this.purchase_price = "";
      }

      if (this.editdata.current_value === "") {
        this.currentValueError = "Vehicle Current Value is required";
        return;
      } else {
        this.currentValueError = "";
      }
      this.EditVehicle(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.plate_number;
      this.deletedata.id = data.item.id;
    },
    deleteVehicle(modalId) {
      this.modal_id = modalId;
      this.DeleteVehicle(this.deletedata);
    },
    addCommas(){
      this.data.purchase_price = this.thousandSeparator(this.data.purchase_price);
      this.data.current_value = this.thousandSeparator(this.data.current_value);
    },
    addEditCommas(){
      this.editdata.purchase_price = this.thousandSeparator(this.editdata.purchase_price);
      this.editdata.current_value = this.thousandSeparator(this.editdata.current_value);
    },
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchVehicles();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Vehicles</h4>
              </div>
              <div
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add-category-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Vehicles ? Vehicles : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(purchase_price)="data">
                  {{ data.item.purchase_price.toLocaleString() }}
                </template>

                <template #cell(current_value)="data">
                  {{ data.item.current_value.toLocaleString() }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-category-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
            </div>
            <Loader v-if="!Vehicles" />
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-category-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add New Vehicle </template>
      <div class="form-group mb-3">
        <label>Vehicle Make</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Make  e.g Toyota, Nissan, Benz, etc."
            class="form-control"
            @input="resetErrors"
            v-model="data.make"
          />
        </div>
        <div class="text-danger" v-if="makeError">
          <em>{{ makeError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Model</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter model  e.g HIACE, Hillux, Premio, Probox  etc"
            class="form-control"
            @input="resetErrors"
            v-model="data.model"
          />
        </div>
        <div class="text-danger" v-if="modelError">
          <em>{{ modelError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Identification Number</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Vehicle Identification Number"
            class="form-control"
            @input="resetErrors"
            v-model="data.vin"
          />
        </div>
        <div class="text-danger" v-if="vinError">
          <em>{{ vinError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Plate Number</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Vehicle Plate Number"
            class="form-control"
            @input="resetErrors()"
            v-model="data.plate_number"
          />
        </div>
        <div class="text-danger" v-if="plateNumberError">
          <em>{{ plateNumberError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Purchase Date</label>
        <div class="input-group">
          <input
            type="date"
            placeholder="Enter Purchase Date"
            class="form-control"
            @input="resetErrors()"
            v-model="data.purchase_date"
          />
        </div>
        <div class="text-danger" v-if="purchaseDateError">
          <em>{{ purchaseDateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Purchase Price</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.purchase_price"
            @input="resetErrors(), addCommas()"
            placeholder="Purchase Price"
          />
        </div>
        <div class="text-danger" v-if="purchasePriceError">
          <em>{{ purchasePriceError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Current Value</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.current_value"
            @input="resetErrors(), addCommas()"
            placeholder="Current value"
          />
        </div>
        <div class="text-danger" v-if="currentValueError">
          <em>{{ currentValueError }}</em>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addVehicle('add-category-modal')"
        >
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="edit-category-modal" hide-footer @hidden="resetEditCat">
      <template #modal-title> Edit Vehicle {{ editdata.plate_number }}</template>
      <div class="form-group mb-3">
        <label>Vehicle Make</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Make  e.g Toyota, Nissan, Benz, etc."
            class="form-control"
            @input="resetErrors"
            v-model="editdata.make"
          />
        </div>
        <div class="text-danger" v-if="makeError">
          <em>{{ makeError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Model</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter model  e.g HIACE, Hillux, Premio, Probox  etc"
            class="form-control"
            @input="resetErrors"
            v-model="editdata.model"
          />
        </div>
        <div class="text-danger" v-if="modelError">
          <em>{{ modelError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Identification Number</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Vehicle Identification Number"
            class="form-control"
            @input="resetErrors"
            v-model="editdata.vin"
          />
        </div>
        <div class="text-danger" v-if="vinError">
          <em>{{ vinError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Vehicle Plate Number</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Vehicle Plate Number"
            class="form-control"
            @input="resetErrors()"
            v-model="editdata.plate_number"
          />
        </div>
        <div class="text-danger" v-if="plateNumberError">
          <em>{{ plateNumberError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Purchase Date</label>
        <div class="input-group">
          <input
            type="date"
            placeholder="Enter Purchase Date"
            class="form-control"
            @input="resetErrors()"
            v-model="editdata.purchase_date"
          />
        </div>
        <div class="text-danger" v-if="purchaseDateError">
          <em>{{ purchaseDateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Purchase Price</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="editdata.purchase_price"
            @input="resetErrors(), addEditCommas()"
            placeholder="Purchase price"
          />
        </div>
        <div class="text-danger" v-if="purchasePriceError">
          <em>{{ purchasePriceError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Current Value</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="editdata.current_value"
            @input="resetErrors(), addEditCommas()"
            placeholder="Current value"
          />
        </div>
        <div class="text-danger" v-if="currentValueError">
          <em>{{ currentValueError }}</em>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editVehicle('edit-category-modal')"
        >
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete category starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-category-modal"
      hide-footer
      @hidden="resetDeleteCat"
    >
      <template #modal-title> Delete Vehicle {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Vehicle? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteVehicle('delete-category-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>  
